import { useRef, useState } from "react";
import useClickOutside from "@/helpers/hook";
import { mapModifiers } from "@/utils/funtion";
import { useData } from "@/stores/context";
import Icon from "@/components/atoms/icon";
import { FaRegUser, FaUser } from "react-icons/fa";
import { TbLogout } from "react-icons/tb";
const DataMenu = [
    { id: 0, icon: <FaRegUser />, name: 'Thông tin tài khoản', type: 'info' },
    { id: 1, icon: <TbLogout style={{ width: 24, fontSize: 18, }} />, name: 'Đăng xuất', type: 'logout' },
]

interface IUserDropdownProps {
    name: string;
    handleClickOption: (type: string) => void;
}

const UserDropdown: React.FC<IUserDropdownProps> = ({
    name, handleClickOption
}) => {
    const { innerWidth } = useData();
    const [visible, setVisible] = useState(false);
    const refUserDropdown = useRef<HTMLDivElement>(null)

    useClickOutside(refUserDropdown, () => {
        setVisible(false);
    });

    return (
        <div className="a-user_dropdown" ref={refUserDropdown} >
            <div className="a-user_dropdown_info" onClick={() => { setVisible(!visible) }}>
                <p> {innerWidth > 1280 &&
                    <FaUser style={{ color: '#fff', width: 24, fontSize: 16, marginLeft: 4 }} />} <strong>{name}</strong></p>
            </div>
            <ul className={mapModifiers('a-user_dropdown_list', visible ? 'active' : 'disable')}>
                {DataMenu.map((item) => (
                    <li key={item.id} onClick={() => handleClickOption(item.type)}>
                        <Icon component={item.icon} size="24x24" />{item.name}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default UserDropdown